import { useEffect, useState } from 'react';

/**
 * Coarse pointer / touch / narrow width only.
 * Do NOT use viewport height — fullscreen on short laptop displays was flipping
 * this flag and remounting the whole UI tree (frozen frame + dead input).
 * `?mobile=1` forces the mobile tree for QA / Browser MCP.
 */
export const IS_MOBILE_MQ =
  '(pointer: coarse), (max-width: 819px)';

export function computeIsMobile(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get('mobile') === '1' || params.get('ui') === 'mobile') return true;
  if (params.get('mobile') === '0' || params.get('ui') === 'desktop') return false;
  const coarse =
    window.matchMedia('(pointer: coarse)').matches ||
    (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);
  const narrow = window.matchMedia('(max-width: 819px)').matches;
  return coarse || narrow;
}

/** Dedicated mobile UI tree when coarse pointer, touch, or narrow viewport. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(computeIsMobile);

  useEffect(() => {
    const update = () => setMobile(computeIsMobile());
    update();
    window.addEventListener('resize', update);
    const mqs = [
      window.matchMedia('(pointer: coarse)'),
      window.matchMedia('(max-width: 819px)'),
    ];
    mqs.forEach((mq) => mq.addEventListener('change', update));
    return () => {
      window.removeEventListener('resize', update);
      mqs.forEach((mq) => mq.removeEventListener('change', update));
    };
  }, []);

  return mobile;
}
